import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  padding: 0 20px;

  .main-banner {
    width: calc(100% + 40px);
    height: 400px;
    margin: 0 -20px;
  }

  .progress-bar,
  .main-banner-pc {
    display: none;
  }

  @media ${({ theme }) => `${theme.media.smMax}, ${theme.media.md}`} {
    padding: ${mixin.pxToVw('0 20')};

    .main-banner {
      width: calc(100% + ${mixin.pxToVw('40')});
      height: ${mixin.pxToVw('400')};
      margin: ${mixin.pxToVw('0 -20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    position: relative;
    padding: 495px 0 0 0;

    .main-banner {
      display: none;
    }

    .main-banner-pc {
      ${mixin.flex({})};
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      column-gap: 18px;
      width: 100%;
      overflow: hidden;

      .thum {
        width: 430px;
        height: 460px;
      }
    }
  }
`;
